import { ApiRequest } from "app/types/api-types";
import { ID, intboolean, ReduxList, Action } from "app/types/app-types";
import { MinMaxType } from "../components/filters";
import { FiltersFormType } from "./filtertypes";
import { ShowGroupType } from "diagnostics/diagnostics";
import { ColorModelType } from "../components/basic-filters";
import { SensitivityType } from 'app/types/model-types';
import { AltWatermarkMaskType } from "products/components/watermark-marker-common";
export type State = ReduxList<any>

export type SimilarProductsType = any

export type FindSimilarType = {
    totalRows: number
    exportedRows: number
    isExporting: boolean
    isExportReady: boolean
    isSearching: boolean
    csvChecksum: string
    error: string
    similarProducts: SimilarProductsType
}

export const SET_PRODUCTS_TO_STORE = 'SET_PRODUCTS_TO_STORE'
export const SET_IS_LOADING_PRODUCTS = 'SET_IS_LOADING_PRODUCTS'
export const SET_FIE_QUERIES_TO_STORE = 'SET_FIE_QUERIES_TO_STORE'
export const GET_FIE_QUERIES = 'GET_FIE_QUERIES'

export const GET_AVAILABLE_OPTIONS: ApiRequest = {
    CREATE: "GET_AVAILABLE_OPTIONS_CREATE",
    STARTED: "GET_AVAILABLE_OPTIONS_STARTED",
    SUCCESS: "GET_AVAILABLE_OPTIONS_SUCCESS",
    ERROR: "GET_AVAILABLE_OPTIONS_ERROR",
}

export const INIT_FORM = 'INIT_FORM'
export const UPDATE_VALUE = 'UPDATE_VALUE'

export interface ProductGeneral {
    filters: FiltersFormType
    data: ExtendedProductType[]
    total_count: number
    page: number
    max_page: number
    project_id: ID
}

export type DiagnosticsType = {
    project_id: number
    template_id: ID
    products: ExtendedProductType
    filters: FiltersFormType
    is_new: boolean
}

export type AvailableOptionsType = {
    product_columns: string[]
    available_status_codes: number[]
    available_mime_types: string[]
    available_lengths: [MinMaxType]
    available_input_widths: [MinMaxType]
    available_input_heights: [MinMaxType]
    available_color_models: ColorModelType[]
    available_elements: string[]
    available_object_positions: string[]
    available_rendered_by: string[]
    available_rendered_types: number[]
    merged_background_colors: string[]
}

export type MergadoElementsType = string[] | string[][]

export type GroupCountsType = {
    group_id: ShowGroupType
    status_code: number
    error_code: number
    total: number
}

export type SortByType = {
    table: string
    column: string
    direction: 'asc' | 'desc' | null
} | ''

export type AlternativeImageRender = {
    id: ID
    project_id: ID
    product_id: ID
    alternative_template_id: ID
    alternative_image_id: ID
    rendered_at: string
    rendered_by: string
    rendered_type: number
    rendered_hash: string
    rendered_size: number
    rendered_compression: number
    rendered_sensitivity: string
    rendered_alt_image_hash: string
    rendered_filename: string
    rendered_level: string
    should_rerender: intboolean
    render_counter: number
    render_error: string
}
export type AlternativeImageTypeWithWatermarkMasks = ImageType & {
    alt_watermark_masks: AltWatermarkMaskType
    alternative_template_id?: ID
    render?: AlternativeImageRender
    bgremoved_edited_objects: string
    bgremoved_edited_hash: string
    inpainted_url: string
}
export type ImageType = {
    id: ID
    url: string
    url_hash: string
    url_hash_prefix: string
    status_code: number | null
    error_code: number | null
    error: string | null
    error_info: string | null
    width: number
    height: number
    content_type: string
    content_length: number
    hash: string
    last_modified_timestamp: number
    bg_color: string
    is_transparent: intboolean
    is_light_bg: intboolean
    is_solid_bg: intboolean
    has_person_confidence: number
    color_space: number
    color_space_string: string
    color_profile: string
    xres: number
    yres: number
    layers_count: number
    object_to_image_ratio: number
    created_at: string
    updated_at: string
    level?: number  //for alternative images only!!!
}

export interface ProductTemplateType {
    id: number
    name: string
    updated_at?: string
    active_from: string
    active_to: string
    active: intboolean
    type: AITemplatType
    is_collage: intboolean
    is_anim_gif: intboolean
    is_autocrop: intboolean
    watermark_group_id: number
    inpainting_group_id: number
    effect_sensitivity?: SensitivityType
    size: {
        id: number
        width: number
        height: number
    }
    visual_similarity_enabled?: intboolean
    visual_similarity_n?: number
    visual_similarity_threshold?: number
    visual_similarity_templateids?: ID[]
}

export const RENDERED_TYPE_UPSCALE = 1;
export const RENDERED_TYPE_BGREMOVE = 2;
export const RENDERED_TYPE_AUTOWMREMOVE = 3;
export const RENDERED_TYPE_OUTPAINTING = 4;
export const RENDERED_TYPE_ANIM_GIF = 5;
export const RENDERED_TYPE_INPAINTING = 6;
export const RENDERED_TYPE_MANUAL_WMREMOVE = 10;
export const RENDERED_TYPE_MANUAL_BGREMOVE_EDITED = 11;

export const RENDERED_TYPES_COLORS = {
    1: 'blue',
    2: 'orange',
    3: 'red',
    4: '#219ebc',
    5: 'yellow',
    6: 'green',
    10: 'red',
    11: 'orange',
    null: '#cccccc',
}

export type AITemplatType = 1 | 2 | 3 | 4 | 5 | 6 | 10 | 11;

export interface ExtendedProductType {
    product_id: ID
    template_id: ID
    project_id: ID
    image_link: string
    rendered_at: string
    rendered_by: string
    rendered_type: AITemplatType
    rendered_hash: string
    rendered_size: number
    should_redownload_priority: number
    should_rerender_priority: number
    rendered_compression: number
    rendered_sensitivity: SensitivityType
    template_effect_sensitivity: SensitivityType
    template_overscan?: number
    template_translate_x?: number
    template_translate_y?: number
    template_outpaint_over?: boolean | intboolean
    alternative_images: AlternativeImageTypeWithWatermarkMasks[]
    should_rerender?: intboolean
    render_error: string
    render_counter?: number

    image_id: ID
    image_width: number
    image_height: number
    image_hash: string
    image_content_type: string
    image_content_length: number
    image_status_code: number
    image_error_code: number
    image_url: string
    image_url_hash: string
    image_bg_color?: string
    image_is_transparent?: intboolean
    image_is_light_bg?: intboolean
    image_is_solid_bg?: intboolean
    image_has_person?: intboolean
    image_color_space?: number
    image_color_space_string?: string
    image_color_profile?: string
    image_xres?: number
    image_yres?: number
    image_layers_count?: number
    image_object_to_image_ratio?: number
    should_redownload?: intboolean
    downloaded_at?: string
    download_counter?: number

    total?: number
    error?: string
    mergado_query?: string
    mergado_id?: string

    template: ProductTemplateType

    elements_item_id: string
    elements_url: string
    elements_price_vat: string
    elements_name: string
    elements_ean: string
    elements_categorytext: string
    elements_manufacturer: string
    elements_productno: string

    validations_mistake_set_by_user: intboolean
    validations_correctness_percentage_offset: number
    validations_has_alpha: intboolean
    validations_status: string
    validations_status_reason: string
    validations_object_position: string
    validations_empty_background_probability: number
    validations_object_to_image_ratio: number
    validations_object_bounding_box_to_image_ratio: number

    watermarks_user_set: intboolean
    watermarks_probability: number
    watermarks_status: string
    watermarks_status_reason: string

    quality_user_set: intboolean
    quality_score: number
    quality_status: string
    quality_status_reason: string

    masks_user_set_objects?: string
    masks_mask_hash?: string
    masks_group_id: ID

    inpainting_group_id?: ID
    inpaintedUrl?: string
    inpaintingMaskUrl?: string

    similar_images?: VisualSimilarityType
    similar_images_list_checksum?: string

    size_width?: number
    size_height?: number
}

export type StatusType = 'OK' | 'NOT_OK' | 'ERROR'
export type ProgressType = 'waiting' | 'queued' | 'done' | 'delete'

export type VisualSimilarityType = {
    id: ID
    project_id: ID
    template_id: ID
    image_hash: string
    queued_list_checksum: string
    list_checksum: string
    progress: ProgressType
    status: StatusType
    status_reason: string
    results: string
    created_at: string
    queued_at: string
    results_at: string
    list_updated_at: string
    priority: number

}

export type WatermarkGroupType = {
    id: number
    group_hash: string
    name: string
    project_id: number
    published_hash: string
    published_at: string
    created_at: string
    updated_at: string
    images?: WatermarkGroupImageType[]
}

export type WatermarkGroupImageType = {
    id: number
    shard: string
    project_id: number
    level: number
    is_alt: boolean
    image_or_alt_id: number
    image_or_alt_hash: string
    filename: string
    width: number
    height: number
    content_type: string
    watermark_group_id: number
    user_set_objects: string
    mask_hash: string
    created_at: string
    updated_at: string
}

export type PositionType = 'topleft' | 'topcenter' | 'topright' | 'center' | 'bottomleft' | 'bottomcenter' | 'bottomright' | 'leftcenter' | 'rightcenter'

export const ALL_POSITIONS: PositionType[] = [
    'topleft', 'topcenter', 'topright',
    'leftcenter', 'center', 'rightcenter',
    'bottomleft', 'bottomcenter', 'bottomright'
]
export type InpaintingGroupType = {
    id: number
    project_id: number
    width: number
    height: number
    user_set_objects: string
    mask_hash: string
    scale_objects: intboolean
    pos_relative_to: PositionType
    created_at: string
    updated_at: string
}